<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 35vw">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">Change Bed & Ward</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form @submit.prevent="submitChange">
          <!-- Current Info -->
          <div class="mb-3">
            <label>Current Ward:</label>
            <input
              type="text"
              class="form-control"
              :value="patient.currentWard"
              disabled
            />
          </div>

          <div class="mb-3">
            <label>Current Bed:</label>
            <input
              type="text"
              class="form-control"
              :value="patient.currentBed"
              disabled
            />
          </div>

          <!-- New Ward -->
          <div class="mb-3">
            <label>New Ward:</label>
            <select v-model="form.newWard" class="form-control" required>
              <option value="" disabled>Select ward</option>
              <option v-for="ward in wards" :key="ward.id" :value="ward.name">
                {{ ward.name }}
              </option>
            </select>
          </div>

          <!-- New Bed -->
          <div class="mb-3">
            <label>New Bed:</label>
            <select v-model="form.newBed" class="form-control" required>
              <option value="" disabled>Select bed</option>
              <option v-for="bed in beds" :key="bed.id" :value="bed.number">
                {{ bed.number }}
              </option>
            </select>
          </div>

          <!-- Effective Date -->
          <div class="mb-3">
            <label>Effective Date:</label>
            <input
              type="date"
              v-model="form.effectiveDate"
              class="form-control"
              required
            />
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="submitChange">
          Confirm Change
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeBedWardModal",
  props: {
    patient: {
      type: Object,
      required: true, // { id, currentWard, currentBed }
    },
  },
  data() {
    return {
      // Dummy wards
      wards: [
        { id: 1, name: "General Ward" },
        { id: 2, name: "ICU" },
        { id: 3, name: "Pediatrics" },
        { id: 4, name: "Maternity" },
      ],
      // Dummy beds
      beds: [
        { id: 1, number: "Bed A1" },
        { id: 2, number: "Bed A2" },
        { id: 3, number: "Bed B1" },
        { id: 4, number: "Bed B2" },
        { id: 5, number: "Bed C1" },
      ],
      form: {
        newWard: "",
        newBed: "",
        effectiveDate: new Date().toISOString().slice(0, 10),
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-change-bed-modal");
    },
    submitChange() {
      this.$emit("change-bed-ward", {
        ...this.form,
        patient_id: this.patient.id,
      });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.mmodal-content {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-footer {
  border-top: 1px solid #ddd;
  justify-content: flex-end;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
